const dateTextCommon = {
  fontSize: 15,
  fontWeight: 500,
  color: '#000000'
}
const slotBoxCommon = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "80px",
  height: "30px",
  border: "1px solid #DEDEDE",
}
const styles = theme => ({
  calendarRoot: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "100%",
    minHeight: "280px",
    paddingTop: "15px",
    border: '1px solid #DEDEDE',
  },
  dayText: {
    ...dateTextCommon
  },
  dayTextBlurred: {
    ...dateTextCommon,
    opacity: 0.5,
    textDecoration: "line-through"
  },
  arrowBox: {
    height: "100%",
    width: "50px",
    margin: "10px"
  },
  subTitleFont: {
    ...dateTextCommon,
    marginBottom: '15px'
  },
  calendarCentralRootBox: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "space-between"
  },
  dayBox: {
    display: "flex",
    flexDirection: "column",
    width: "100px",
    height: "100%",
  },
  dayAndDateBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: 'center',
    justifyContent: 'center',
    width: '80px',
    height: '40px'
  },
  slotBox: {
    ...slotBoxCommon,
    marginBottom: "10px",
    cursor: 'pointer',
  },
  bookedSlotBox: {
    ...slotBoxCommon,
    marginBottom: "10px",
    pointerEvents: 'none'
  },
  bookedSlotBoxWithPointerEvent: {
    ...slotBoxCommon,
    marginBottom: "10px",
  },
  selectedSlotBox: {
    ...slotBoxCommon,
    marginBottom: "10px",
    border: "1px solid #FA6401",
    pointerEvents: 'none'
  },
  moreBox: {
    ...slotBoxCommon,
    marginBottom: "10px",
    backgroundColor: '#F3F5F7',
    cursor: 'pointer',
  },
  arrowIcon: {
    cursor: 'pointer',
  },
});

export default styles;